var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourtSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 64,
    viewBox: "0 0 237 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.513 20.9877L103.803 63.3506L2.487 43.0122L133.197 0.649292L234.513 20.9877Z",
    stroke: "#D93C32",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6581 46.8906L69.8804 56.5423L35.8109 49.7021L65.5863 40.0522L99.6581 46.8906Z",
    stroke: "#D93C32",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5329 46.0626L65.7552 55.7142L39.9865 50.5407L69.7642 40.8908L95.5329 46.0626Z",
    stroke: "#D93C32",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.975 43.5571C99.0148 41.3167 91.8467 39.4173 82.9646 39.3147C74.0825 39.2122 66.8499 40.9453 66.8101 43.1857C66.7704 45.4261 73.9386 47.3254 82.8207 47.428C91.7027 47.5305 98.9353 45.7975 98.975 43.5571Z",
    stroke: "#D93C32",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.119 57.6234L92.5196 61.0576L14.3647 45.369L24.966 41.933C41.2453 36.6568 71.9376 35.8925 93.5197 40.2256C115.1 44.5569 119.398 52.3473 103.119 57.6234Z",
    stroke: "#D93C32",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.287 17.0987L167.065 7.44708L201.134 14.2873L171.357 23.9372L137.287 17.0987Z",
    stroke: "#D93C32",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.412 17.9268L171.19 8.27515L196.959 13.4487L167.181 23.0985L141.412 17.9268Z",
    stroke: "#D93C32",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170.16 20.7879C170.2 18.5475 163.032 16.6481 154.149 16.5456C145.267 16.443 138.035 18.176 137.995 20.4165C137.955 22.6569 145.123 24.5563 154.006 24.6589C162.888 24.7614 170.12 23.0283 170.16 20.7879Z",
    stroke: "#D93C32",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.829 6.36783L144.428 2.93173L222.58 18.6221L211.981 22.0564C195.702 27.3325 165.01 28.0986 143.428 23.7655C121.846 19.4325 117.547 11.644 133.829 6.36783Z",
    stroke: "#D93C32",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M134.852 32.1809C134.892 29.9043 127.609 27.9743 118.584 27.8701C109.559 27.7659 102.21 29.527 102.169 31.8035C102.129 34.0801 109.413 36.0101 118.438 36.1143C127.462 36.2185 134.811 34.4575 134.852 32.1809Z",
    stroke: "#D93C32",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2114 21.8936L169.317 42.1913",
    stroke: "#D93C32",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourtSmall);
export default __webpack_public_path__ + "static/media/court-small.838efa9a.svg";
export { ForwardRef as ReactComponent };